import { Api, ApiRequest, ResType } from '@api'
import { Logger } from '@utils'
import { GetSeasonProductQueryType, SeasonProductBatchUpdateType } from '@schemas'

export const getSeasonProduct = async ({
	params = {},
	body = {},
	query = {
		seasonId: '',
	} as GetSeasonProductQueryType,
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = '/season-product'
		const req = new ApiRequest({
			method: 'get',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)

		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const batchUpdateSeasonProduct = async ({
	params = {},
	query = {},
	body = { productList: [] as SeasonProductBatchUpdateType[] },
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = '/season-product/batch-update'
		const req = new ApiRequest({
			method: 'put',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)

		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const getShopSeasonProduct = async ({
	params = {},
	body = {},
	query = {
		seasonId: '',
	} as GetSeasonProductQueryType,
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = '/season-product/shop'
		const req = new ApiRequest({
			method: 'get',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
			isRequiredToken: false,
		})

		const result: ResType = await Api.connection(req)

		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const getShopSeasonProductDetail = async ({
	params = { sessionProductId: '' },
	body = {},
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = `/season-product/shop/${params.sessionProductId}`
		const req = new ApiRequest({
			method: 'get',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
			isRequiredToken: false,
		})

		const result: ResType = await Api.connection(req)

		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

const seasonProductApi = {
	getSeasonProduct: getSeasonProduct,
	batchUpdateSeasonProduct: batchUpdateSeasonProduct,
	getShopSeasonProduct: getShopSeasonProduct,
	getShopSeasonProductDetail: getShopSeasonProductDetail,
}

export default seasonProductApi
